<template>
    <div class="search">
        <div class="search-fixed">
            <div class="search-btn">
                <div class="search-btn-col">
                    <span class="search-btn-icon iconfont iconfangdajing"></span>
                    <div class="btn-input">
                        <input class="search-btn-input"
                               v-model="search_value"
                               @input="searchInput"
                               @keyup.enter="searchConfirm"
                               placeholder="搜索课程"/>
                    </div>
                    <span v-if="search_input.length>0" @click="bindSearchEliminate" class="search-btn-eliminate iconfont iconguanbi-"></span>
                </div>
                <div class="search-btn-close" @click="bindBack">
                    取消
                </div>
            </div>
        </div>
        <div v-if="list.length == 0">
            <div class="hot-history" v-if="!is_show_empty">
                <div class="hot-search" v-if="hot_list.length > 0">
                    <div class="hot-search-title">热门搜索</div>
                    <div class="hot-search-list">
                        <span class="hot-search-li" v-for="(item,index) in hot_list" :data-keyword="item.keyword" @click="bindSetSearch">{{item.keyword}}</span>
                    </div>
                </div>
                <div class="history-search" v-if="history_list.length > 0">
                    <div class="history-search-title">
                        历史搜索
                        <div class="iconfont iconlaji" @click="bindEmptyHistory"></div>
                    </div>
                    <div class="history-search-list">
                        <span class="history-search-li" v-for="(item,index) in history_list" :data-keyword="item" @click="bindSetSearch">{{item}}</span>
                    </div>
                </div>
            </div>
            <div class="empty" v-if="is_show_empty">
                <van-empty image="search" description="搜索不到您要结果，换个关键词试试呗" />
            </div>
        </div>
        <div v-if="list.length > 0">
            <div class="search-list">

                <van-list
                        v-model="loading"
                        :finished="is_show"
                        offset="50"
                        finished-text="暂无更多信息"
                        :immediate-check="false"
                        @load="bindSearchList"
                >

                <div class="search-li" v-for="(item,index) in list" :key="index" :data-id="item.course_id" @click="bindGoCurriculum">
                    <div class="search-li-image">
                        <van-image :src="item.cover_url"
                                   width="100%"
                                   height="100%"
                                   fit="fill"/>
                        <div class="content-info-view">
                            <span class="iconfont iconchakan"></span>
                            {{item.view_count}}
                        </div>
                    </div>
                    <div class="search-li-content">
                        <div class="search-content-name">
                        <span v-for="(items,indexs) in item.name"
                              :key="indexs"
                              :style="items.key?'color:#FF624F':''">{{items.str}}</span>
                        </div>
                        <div class="search-content-col">
                            {{item.lecturer}}
                        </div>
                        <div class="search-content-flex">
                            <div class="search-content-cnt">
                                <span v-if="(item.online_section_cnt*1) == 0">更新中</span>
                                <span v-else>更新至{{item.online_section_cnt}}期</span>
                            </div>
                            <div class="search-content-money">
                                {{item.money*1==0 ?'免费':'￥'+(item.money*1)}}
                            </div>
                        </div>
                    </div>
                </div>

                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
    import {Empty,Dialog,List,Image as VanImage} from 'vant';
    export default {
        name: "index",
        components:{
            [Empty.name]:Empty,
            [List.name]:List,
            [VanImage.name]:VanImage
        },
        data(){
            return {
                search_input:'',
                search_value:'',
                is_show_empty:false,//是否显示提示
                loading:false,
                hot_list:[],//热门搜索
                history_list:[],//历史搜索
                list:[],
                total:0,
                is_show:false,
                page:1,
                pagesize:10,
                history_storage:this.util.token + '_history'
            }
        },
        beforeCreate () {
            document.querySelector('body').setAttribute('style', 'background-color:#fff')
        },
        //离开页面事件
        beforeRouteLeave(to, form, next) {

            localStorage.setItem(this.history_storage,JSON.stringify(this.history_list));
            document.querySelector('body').setAttribute('style', 'background-color:#f8f8f8')

            next();
        },
        mounted() {
            this.history_list = JSON.parse(localStorage.getItem(this.history_storage)) || [];
            this.bindHotSeachList();
        },
        methods:{
            //热门搜索
            bindHotSeachList: function () {
                var _self=this;
                this.util.server.mini_home.hot_search({
                    callback:function(res) {
                        _self.hot_list = res.data
                    }
                })
            },
            //清空历史搜索
            bindEmptyHistory: function () {
                var _self=this;
                Dialog.confirm({
                    message: '确定清空全部历史搜索记录？',
                })
                .then((res) => {
                    // on confirm
                    _self.history_list=[];
                })
                .catch((res) => {
                    // on cancel
                });
            },
            //取消，返回上一页
            bindBack: function () {
                this.$router.back();
            },
            //清空搜索内容
            bindSearchEliminate: function () {
                this.search_input='';
                this.search_value='';
                this.is_show_empty=false;
                this.list=[];
            },
            //设置搜索内容
            searchInput: function (e) {
                this.search_input = e.target.value;

                if(this.search_input == ''){
                    this.bindSearchEliminate();
                }
            },
            //点击热门/历史进行搜索
            bindSetSearch: function (e) {
                this.search_input = e.currentTarget.dataset.keyword;
                this.search_value = e.currentTarget.dataset.keyword;

                this.bindSearchList(1);
            },
            //搜索
            searchConfirm: function (e) {
                var val = e.target.value;
                if(val.length == 0){
                    return false;
                }
                if(this.util.trim(val).length == 0){
                    return this.is_show_empty=true;
                }

                this.bindSearchList(1);

            },
            bindHistoryUpdate: function (val) {

                var arr_history=this.history_list;

                if(arr_history.indexOf(val) > -1){
                    for (var i =0;i<arr_history.length;i++) {
                        if(arr_history[i] == val){
                            arr_history.splice(i,1);
                            break;
                        }
                    }
                }

                arr_history.unshift(val);

                if(arr_history.length>10){
                    arr_history.pop();
                }

                this.history_list=arr_history;
            },
            //搜索列表
            bindSearchList: function (page) {
                var _self=this ;
                if(!page){
                    var pageNo = this.page;
                    pageNo +=1;

                    this.page = pageNo;

                }else{

                    this.page = page;

                }
                this.util.server.mini_home.search({
                    data:{
                        keyword : this.util.trim(this.search_input),
                        page:this.page,
                        pagesize:this.pagesize
                    },
                    callback:function (res) {
                        const { code, data, msg } = res;

                        _self.loading=false;

                        if(code == 1){

                            //赋值总数量
                            if(data.total){
                                _self.total = data.total
                            }
                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                for (var i = 0 ; i<data.items.length; i++){
                                    data.items[i].name = _self.util.hilight_word(_self.util.trim(_self.search_input),data.items[i].name)
                                }

                                if(page == 1){
                                    _self.list = data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    _self.list = _self.list.concat(data.items);
                                }

                                //判断是否存在下一页
                                _self.is_show = false;
                                _self.is_show_empty = false;

                                if(_self.total*1 == _self.list.length){
                                    _self.is_show=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    _self.list=[];
                                    _self.is_show_empty = true;
                                }
                            }

                        }else {
                            _self.util.showToast({
                                message: msg,
                            });
                        }

                        _self.bindHistoryUpdate(_self.util.trim(_self.search_input));

                    }
                })
            },
            bindGoCurriculum:function(e){
                this.$router.push(this.util.urlPrefix+'/curriculum/index?course_id='+e.currentTarget.dataset.id+'&token='+this.util.token)

            },
        }
    }
</script>

<style scoped>
    body{
        background-color: #fff;
    }
    div{
        color: #3a3a3a;
    }
    input {
        display: block;
        height: 24px;
        text-overflow: clip;
        overflow: hidden;
        white-space: nowrap;
        min-height: 24px;
        background-color: transparent;
        border: 0;
        padding: 0;
    }
    .search{
        padding: 10px;
        box-sizing: border-box;
    }
    .search-fixed{
        position: fixed;
        width: 100%;
        left: 0;
        padding: 0 10px;
        box-sizing: border-box;
        top: 0;
        background-color: #fff;
        z-index: 1;
        padding-bottom: 10px;
    }
    .search-btn{
        display: flex;
        height: 36px;
        margin-top: 10px;
    }
    .search-btn-col{
        background-color: #F5F6F5;
        border-radius: 30px;
        padding: 7px 12px;
        flex: 1;
        position: relative;
    }
    .search-btn-icon{
        color: #999999;
        position: absolute;
        top: 50%;
        margin-top: -8.5px;
    }
    .btn-input{
        width: 100%;
        padding-left: 27px;
        box-sizing: border-box;
        padding-right: 24px;
    }
    .search-btn-input{
        width: 100%;
    }
    .search-btn-close{
        margin: 0 10px;
        margin-left: 20px;
        line-height: 36px;
    }
    .search-btn-eliminate{
        color: #999999;
        position: absolute;
        top: 50%;
        right: 12px;
        margin-top: -8.5px;
    }
    .hot-history{
        margin-top: 56px;
    }
    .hot-search-title,.history-search-title{
        color: #999;
        margin: 10px 0;
        position: relative;
    }
    .hot-search-li,.history-search-li{
        padding: 4px 12px;
        background-color: #F5F6F5;
        border-radius: 20px;
        display: inline-block;
        margin-right: 20px;
        margin-bottom: 10px;
        margin-top: 6px;
        max-width: 192px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .history-search-title .iconfont{
        position: absolute;
        top: 50%;
        right: 0;
        font-size: 12px;
        color: #999;
        margin-top: -7px;
    }
    .empty{
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 32px 0;
    }
    .empty-image{
        width: 160px;
        height: 160px;
    }
    .empty-image image{
        width: 100%;
        height: 100%;
    }
    .empty-description{
        color: #999999;
        font-size: 12px;
    }
    .search-list{
        margin-top: 56px;
    }
    .search-li{
        width: 100%;
        height: 101px;
        margin-top: 20px;
    }
    .search-li-image{
        border-radius: 5px;
        overflow: hidden;
        width: 135px;
        height: 101px;
        position: absolute;
    }
    .search-li-image image{
        border-radius: 5px;
        width: 100%;
        height: 100%;
        position: relative;
    }
    .search-li-content{
        padding-left: 145px;
    }
    .search-content-name{
        color: #171717;
        font-weight: 500;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
        overflow: hidden;
        height: 38px;
    }
    .search-content-col{
        font-size: 12px;
        color: #999999;
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        white-space: normal;
        margin-top: 8px;
        margin-bottom: 15px;
        height: 16px;
    }
    .search-content-flex{
        display: flex;
    }
    .search-content-cnt{
        flex: 1;
        font-size: 12px;
        color: #999999;
    }
    .search-content-money{
        font-size: 12px;
        color: #FF624F;
    }
    .content-info-view{
        position: absolute;
        font-size: 10px;
        color: #ffffff;
        top: 0;
        margin: 6px;
        padding: 2px 6px;
        background: rgba(0,0,0,0.4);
        border-radius: 8px;
    }
    .content-info-view .iconfont{
        font-size: 10px;
    }
    .empty >>> .van-empty__description{
        padding: 0;
    }
</style>
